/**
 * @fileOverView
 * @description Schedule View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var ScheduleTemplate = require('../../templates/components/schedule.html');
var AmpersandView = require('ampersand-view');
var app = require('ampersand-app');

var ScheduleView = AmpersandView.extend({

    autoRender: true,

    template : ScheduleTemplate,

    initialize: function(options){
        for (const key in options){
            this[key] = options[key];
        }
    },

    bindings: {
        schedule_sentences : {
            "hook" : "schedule_sentences",
            "type" : "innerHTML"
        },
        schedule_timezone : {
            "hook" : "schedule_timezone",
            "type" : "text"
        }
    },


});

module.exports = ScheduleView;
